import React, { useEffect, useState } from 'react';
import styles from '../../formStyles.module.css';
import FormItem from '@/components/common/FormItem';
import { useLayoutContext } from '@/context/LayoutContext';
import { useTranslations } from 'next-intl';
import Api from '@/api';
import MobilePrefix from '@/components/common/MobilePrefix';

export default function Level1({ info, setInfo, onChange, onKeyDown }) {
  const tCommon = useTranslations('common');
  let formarray = [
    {
      id: 1,
      type: 'input',
      extraInfo: '*',
      styleColor: 'starColor',
      placeholder: tCommon('mobile'),
      title: tCommon('mobile'),
      error: info?.messages?.mobile,
      // extraInfo: ' * ',
      // styleColor: `starColor`,
      showError: info?.error?.mobile,
      value: info?.mobile,
      key: 'mobile',
      wrapper: `lightInput`,
      prefix: <MobilePrefix />,
      onKeyDown: onKeyDown,
      inputType: 'number',
    },
  ];

  const [formList, setFormList] = useState(formarray);

  useEffect(() => {
    if (info) {
      setFormList(formarray);
    }
  }, [info]);

  console.log('info==', info);

  return (
    <>
      <div className={`${styles.formContainer} ${styles.formContainerGrid1}`}>
        {formList?.map((item, index) => (
          <FormItem
            type={item.type}
            inputType={item.inputType}
            key={index}
            item={item}
            index={index}
            onChange={onChange}
            value={info?.[`${item?.key}`]}
          ></FormItem>
        ))}
      </div>
    </>
  );
}
